<!-- Label centré (Figma: bold, centered above input) -->
@if (label) {
  <div class="date-picker-label">
    <span class="date-picker-label__text">{{ label }}</span>
    @if (required) {
      <span class="date-picker-label__required">*</span>
    }
  </div>
}

<!-- Input wrapper -->
<div
  class="date-picker-wrapper"
  [class.date-picker-wrapper--focused]="isFocused()"
  [class.date-picker-wrapper--error]="showError"
  [class.date-picker-wrapper--disabled]="disabled"
  (click)="openPicker()"
>
  <!-- Champ natif de type date -->
  <input
    #dateInput
    class="date-picker-field"
    type="date"
    [disabled]="disabled"
    [required]="required"
    [value]="value()"
    (input)="onInput($event)"
    (focus)="onFocus()"
    (blur)="onBlur()"
    (click)="$event.stopPropagation()"
  />

  <!-- Icône calendrier -->
  <span class="date-picker-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M5.33333 1.33334V3.33334M10.6667 1.33334V3.33334M2 6.00001H14M3.33333 2.66668H12.6667C13.4031 2.66668 14 3.26363 14 4.00001V13.3333C14 14.0697 13.4031 14.6667 12.6667 14.6667H3.33333C2.59695 14.6667 2 14.0697 2 13.3333V4.00001C2 3.26363 2.59695 2.66668 3.33333 2.66668Z" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </span>
</div>

<!-- Message d'erreur -->
@if (showError) {
  <span class="date-picker-error" role="alert">
    {{ errorMessage }}
  </span>
}
